import {
  Target,
  Book,
  Code,
  Briefcase,
  FlaskConical,
  Palette,
  Dumbbell,
  Home,
  Lightbulb,
  Rocket,
  Heart,
  Users,
  GraduationCap,
  Wrench,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const BOARD_ICON_KEYS = [
  "target",
  "book",
  "code",
  "briefcase",
  "flask",
  "palette",
  "dumbbell",
  "home",
  "lightbulb",
  "rocket",
  "heart",
  "users",
  "graduation-cap",
  "wrench",
] as const;

export type BoardIconKey = (typeof BOARD_ICON_KEYS)[number];

export const BOARD_ICON_MAP: Record<BoardIconKey, LucideIcon> = {
  target: Target,
  book: Book,
  code: Code,
  briefcase: Briefcase,
  flask: FlaskConical,
  palette: Palette,
  dumbbell: Dumbbell,
  home: Home,
  lightbulb: Lightbulb,
  rocket: Rocket,
  heart: Heart,
  users: Users,
  "graduation-cap": GraduationCap,
  wrench: Wrench,
};

export function getBoardIconComponent(key: string | null | undefined): LucideIcon | null {
  if (!key) return null;
  const k = key as BoardIconKey;
  return BOARD_ICON_MAP[k] ?? null;
}
